module.exports = "https://static.wmbcdn.com/uniweb/images/4371c7baf3620cca540b31ca4428d214.svg";